import { DevicePhoneMobileIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import { PrimaryButton } from "components/ui/primary-button";
import { TwoFactorMethod } from "generated/graphql";
import React from "react";

interface TwoFactorMethodSelectorProps {
    methods: TwoFactorMethod[];
    onMethodSelect: (method: TwoFactorMethod) => void;
    onBack?: () => void;
    loading?: boolean;
    backButtonText?: string;
}

export const TwoFactorMethodSelector: React.FC<TwoFactorMethodSelectorProps> = ({
    methods,
    onMethodSelect,
    onBack,
    loading = false,
    backButtonText = "Back",
}) => {
    return (
        <div>
            <div className="mb-6 text-gray-600">
                Choose a method to receive your verification code:
            </div>
            <div className="space-y-4">
                {methods.includes(TwoFactorMethod.Sms) && (
                    <PrimaryButton
                        type="button"
                        onClick={() => onMethodSelect(TwoFactorMethod.Sms)}
                        disabled={loading}
                        className="w-full flex items-center justify-center gap-2">
                        <DevicePhoneMobileIcon className="w-5 h-5" /> SMS
                    </PrimaryButton>
                )}
                {methods.includes(TwoFactorMethod.Email) && (
                    <PrimaryButton
                        type="button"
                        onClick={() => onMethodSelect(TwoFactorMethod.Email)}
                        disabled={loading}
                        className="w-full flex items-center justify-center gap-2">
                        <EnvelopeIcon className="w-5 h-5" /> Email
                    </PrimaryButton>
                )}
                {onBack && (
                    <div className="text-center">
                        <button
                            type="button"
                            onClick={onBack}
                            disabled={loading}
                            className="text-blue-600 hover:text-blue-800 text-sm disabled:text-gray-400">
                            {backButtonText}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};
